import { render, staticRenderFns } from "./VDealProperties.vue?vue&type=template&id=6e899a1e"
import script from "./VDealProperties.vue?vue&type=script&lang=js"
export * from "./VDealProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports